"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _slotMachine = _interopRequireDefault(require("./components/slot-machine"));
var _slotMachineContext = require("./store/slot-machine-context");
var _ModalState = _interopRequireDefault(require("./modal/ModalState"));
var _Modal = _interopRequireDefault(require("./components/Modal"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Codewheel() {
  const [modalData, setModalData] = (0, _react.useState)(null);
  const [shouldCloseModal, setShouldCloseModal] = (0, _react.useState)(false);
  const modalSubscriptionHelper = {
    notify(eventTopic, eventData) {
      switch (eventTopic) {
        case "SetModal":
          setModalData(eventData);
          break;
        case "CloseModal":
          setShouldCloseModal(true);
          break;
        case "UpdateModalProps":
          setModalData(prevModalData => {
            if (prevModalData) {
              return _objectSpread(_objectSpread({}, prevModalData), eventData);
            }
            return prevModalData;
          });
          break;
      }
    }
  };

  // Create subscription to the modal states
  (0, _react.useEffect)(() => {
    // Subscribe
    _ModalState.default.subscribe(modalSubscriptionHelper, ["SetModal", "CloseModal", "UpdateModalProps"]);
    // Return unsubscribe function
    return () => {
      _ModalState.default.unsubscribe(modalSubscriptionHelper);
    };
  }, []);
  const resetModal = () => {
    setShouldCloseModal(false);
    setModalData(null);
  };
  const ModalContent = modalData === null || modalData === void 0 ? void 0 : modalData.modalContent;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_slotMachineContext.SlotMachineContextProvider, {
    children: [!!ModalContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
      title: modalData ? modalData.modalTitle || "" : "",
      modalResetter: resetModal,
      shouldCloseModal: shouldCloseModal,
      withLogo: true,
      withCloseButton: modalData === null || modalData === void 0 ? void 0 : modalData.withCloseButton,
      children: ModalContent
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_slotMachine.default, {})]
  });
}
var _default = exports.default = Codewheel;